import { render, staticRenderFns } from "./ComposableSquareBrick.vue?vue&type=template&id=ccc4a00a&scoped=true&"
import script from "./ComposableSquareBrick.vue?vue&type=script&lang=js&"
export * from "./ComposableSquareBrick.vue?vue&type=script&lang=js&"
import style0 from "../../Style/composable-square-brick.scss?vue&type=style&index=0&id=ccc4a00a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc4a00a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccc4a00a')) {
      api.createRecord('ccc4a00a', component.options)
    } else {
      api.reload('ccc4a00a', component.options)
    }
    module.hot.accept("./ComposableSquareBrick.vue?vue&type=template&id=ccc4a00a&scoped=true&", function () {
      api.rerender('ccc4a00a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Menu/ComposableSquareBrick.vue"
export default component.exports